export default __webpack_public_path__ + "static/ainc-workspace-hero-dee943c5bfd8067ac48fc51ad5d8a893.jpeg";